module.exports = __webpack_public_path__ + "img/piping_width.95cd4672.png";